"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5397,7026,5720],{

/***/ 51469:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Sx": function() { return /* binding */ useBreakpointValue; }
/* harmony export */ });
/* unused harmony exports Hide, Show, useBreakpoint, useColorModePreference, useMediaQuery, usePrefersReducedMotion, useQuery */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _chakra_ui_system__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(83904);
/* harmony import */ var _chakra_ui_react_env__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(18229);
/* harmony import */ var _chakra_ui_breakpoint_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(54302);
// ../../../react-shim.js


// src/media-query.tsx

var getBreakpoint = (theme, value) => {
  var _a;
  return ((_a = theme == null ? void 0 : theme.breakpoints) == null ? void 0 : _a[value]) ?? value;
};
function useQuery(props) {
  const { breakpoint = "", below, above } = props;
  const theme = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_1__/* .useTheme */ .Fg)();
  const bpBelow = getBreakpoint(theme, below);
  const bpAbove = getBreakpoint(theme, above);
  let query = breakpoint;
  if (bpBelow) {
    query = `(max-width: ${bpBelow})`;
  } else if (bpAbove) {
    query = `(min-width: ${bpAbove})`;
  }
  return query;
}

// src/use-media-query.ts


function useMediaQuery(query, options = {}) {
  const { ssr = true, fallback } = options;
  const env = (0,_chakra_ui_react_env__WEBPACK_IMPORTED_MODULE_2__/* .useEnvironment */ .O)();
  const queries = Array.isArray(query) ? query : [query];
  let fallbackValues = Array.isArray(fallback) ? fallback : [fallback];
  fallbackValues = fallbackValues.filter((v) => v != null);
  const [value, setValue] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(() => {
    return queries.map((query2, index) => ({
      media: query2,
      matches: ssr ? !!fallbackValues[index] : env.window.matchMedia(query2).matches
    }));
  });
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    setValue(queries.map((query2) => ({
      media: query2,
      matches: env.window.matchMedia(query2).matches
    })));
    const mql = queries.map((query2) => env.window.matchMedia(query2));
    const handler = (evt) => {
      setValue((prev) => {
        return prev.slice().map((item) => {
          if (item.media === evt.media)
            return { ...item, matches: evt.matches };
          return item;
        });
      });
    };
    mql.forEach((mql2) => {
      if (typeof mql2.addListener === "function") {
        mql2.addListener(handler);
      } else {
        mql2.addEventListener("change", handler);
      }
    });
    return () => {
      mql.forEach((mql2) => {
        if (typeof mql2.removeListener === "function") {
          mql2.removeListener(handler);
        } else {
          mql2.removeEventListener("change", handler);
        }
      });
    };
  }, [env.window]);
  return value.map((item) => item.matches);
}

// src/media-query.hook.ts
function usePrefersReducedMotion(options) {
  const [prefersReducedMotion] = useMediaQuery("(prefers-reduced-motion: reduce)", options);
  return prefersReducedMotion;
}
function useColorModePreference(options) {
  const [isLight, isDark] = useMediaQuery(["(prefers-color-scheme: light)", "(prefers-color-scheme: dark)"], options);
  if (isLight)
    return "light";
  if (isDark)
    return "dark";
  return void 0;
}

// src/use-breakpoint.ts


// ../../utilities/shared-utils/src/index.ts
function isObject(value) {
  const type = typeof value;
  return value != null && (type === "object" || type === "function") && !Array.isArray(value);
}

// src/use-breakpoint.ts
function useBreakpoint(arg) {
  var _a;
  const opts = isObject(arg) ? arg : { fallback: arg ?? "base" };
  const theme = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_1__/* .useTheme */ .Fg)();
  const breakpoints = theme.__breakpoints.details.map(({ minMaxQuery, breakpoint }) => ({
    breakpoint,
    query: minMaxQuery.replace("@media screen and ", "")
  }));
  const fallback = breakpoints.map((bp) => bp.breakpoint === opts.fallback);
  const values = useMediaQuery(breakpoints.map((bp) => bp.query), { fallback, ssr: opts.ssr });
  const index = values.findIndex((value) => value == true);
  return ((_a = breakpoints[index]) == null ? void 0 : _a.breakpoint) ?? opts.fallback;
}

// src/use-breakpoint-value.ts



// src/media-query.utils.ts

function getClosestValue(values, breakpoint, breakpoints = _chakra_ui_breakpoint_utils__WEBPACK_IMPORTED_MODULE_3__/* .breakpoints */ .AV) {
  let index = Object.keys(values).indexOf(breakpoint);
  if (index !== -1) {
    return values[breakpoint];
  }
  let stopIndex = breakpoints.indexOf(breakpoint);
  while (stopIndex >= 0) {
    const key = breakpoints[stopIndex];
    if (values.hasOwnProperty(key)) {
      index = stopIndex;
      break;
    }
    stopIndex -= 1;
  }
  if (index !== -1) {
    const key = breakpoints[index];
    return values[key];
  }
  return void 0;
}

// src/use-breakpoint-value.ts
function useBreakpointValue(values, arg) {
  var _a;
  const opts = isObject(arg) ? arg : { fallback: arg ?? "base" };
  const breakpoint = useBreakpoint(opts);
  const theme = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_1__/* .useTheme */ .Fg)();
  if (!breakpoint)
    return;
  const breakpoints = Array.from(((_a = theme.__breakpoints) == null ? void 0 : _a.keys) || []);
  const obj = Array.isArray(values) ? Object.fromEntries(Object.entries((0,_chakra_ui_breakpoint_utils__WEBPACK_IMPORTED_MODULE_3__/* .arrayToObjectNotation */ .Yq)(values, breakpoints)).map(([key, value]) => [key, value])) : values;
  return getClosestValue(obj, breakpoint, breakpoints);
}

// src/visibility.tsx
function Visibility(props) {
  const { breakpoint, hide, children, ssr } = props;
  const [show] = useMediaQuery(breakpoint, { ssr });
  const isVisible = hide ? !show : show;
  const rendered = isVisible ? children : null;
  return rendered;
}

// src/show.tsx
function Show(props) {
  const { children, ssr } = props;
  const query = useQuery(props);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Visibility, {
    breakpoint: query,
    ssr
  }, children);
}
Show.displayName = "Show";

// src/hide.tsx
function Hide(props) {
  const { children, ssr } = props;
  const query = useQuery(props);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Visibility, {
    breakpoint: query,
    hide: true,
    ssr
  }, children);
}
Hide.displayName = "Hide";



/***/ }),

/***/ 57026:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ph": function() { return /* binding */ Select; }
/* harmony export */ });
/* unused harmony exports DefaultIcon, SelectField */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _chakra_ui_form_control__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(83234);
/* harmony import */ var _chakra_ui_system__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(83904);
/* harmony import */ var _chakra_ui_system__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(54520);
// ../../../react-shim.js


// src/select.tsx



// ../../utilities/shared-utils/src/index.ts
var cx = (...classNames) => classNames.filter(Boolean).join(" ");
var dataAttr = (condition) => condition ? "" : void 0;

// ../../utilities/object-utils/src/index.ts
function split(object, keys) {
  const picked = {};
  const omitted = {};
  for (const [key, value] of Object.entries(object)) {
    if (keys.includes(key))
      picked[key] = value;
    else
      omitted[key] = value;
  }
  return [picked, omitted];
}

// src/select.tsx


// src/select-field.tsx

var SelectField = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_1__/* .forwardRef */ .Gp)(function SelectField2(props, ref) {
  const { children, placeholder, className, ...rest } = props;
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_chakra_ui_system__WEBPACK_IMPORTED_MODULE_1__/* .chakra.select */ .m$.select, {
    ...rest,
    ref,
    className: cx("chakra-select", className)
  }, placeholder && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("option", {
    value: ""
  }, placeholder), children);
});
SelectField.displayName = "SelectField";

// src/select.tsx
var Select = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_1__/* .forwardRef */ .Gp)((props, ref) => {
  var _a;
  const styles = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_1__/* .useMultiStyleConfig */ .jC)("Select", props);
  const {
    rootProps,
    placeholder,
    icon,
    color,
    height,
    h,
    minH,
    minHeight,
    iconColor,
    iconSize,
    ...rest
  } = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_2__/* .omitThemingProps */ .Lr)(props);
  const [layoutProps, otherProps] = split(rest, _chakra_ui_system__WEBPACK_IMPORTED_MODULE_2__/* .layoutPropNames */ .oE);
  const ownProps = (0,_chakra_ui_form_control__WEBPACK_IMPORTED_MODULE_3__/* .useFormControl */ .Yp)(otherProps);
  const rootStyles = {
    width: "100%",
    height: "fit-content",
    position: "relative",
    color
  };
  const fieldStyles = {
    paddingEnd: "2rem",
    ...styles.field,
    _focus: {
      zIndex: "unset",
      ...(_a = styles.field) == null ? void 0 : _a["_focus"]
    }
  };
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_chakra_ui_system__WEBPACK_IMPORTED_MODULE_1__/* .chakra.div */ .m$.div, {
    className: "chakra-select__wrapper",
    __css: rootStyles,
    ...layoutProps,
    ...rootProps
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(SelectField, {
    ref,
    height: h ?? height,
    minH: minH ?? minHeight,
    placeholder,
    ...ownProps,
    __css: fieldStyles
  }, props.children), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(SelectIcon, {
    "data-disabled": dataAttr(ownProps.disabled),
    ...(iconColor || color) && { color: iconColor || color },
    __css: styles.icon,
    ...iconSize && { fontSize: iconSize }
  }, icon));
});
Select.displayName = "Select";
var DefaultIcon = (props) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", {
  viewBox: "0 0 24 24",
  ...props
}, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
  fill: "currentColor",
  d: "M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z"
}));
var IconWrapper = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_1__/* .chakra */ .m$)("div", {
  baseStyle: {
    position: "absolute",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    pointerEvents: "none",
    top: "50%",
    transform: "translateY(-50%)"
  }
});
var SelectIcon = (props) => {
  const { children = /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(DefaultIcon, null), ...rest } = props;
  const clone = (0,react__WEBPACK_IMPORTED_MODULE_0__.cloneElement)(children, {
    role: "presentation",
    className: "chakra-select__icon",
    focusable: false,
    "aria-hidden": true,
    style: {
      width: "1em",
      height: "1em",
      color: "currentColor"
    }
  });
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(IconWrapper, {
    ...rest,
    className: "chakra-select__icon-wrapper"
  }, (0,react__WEBPACK_IMPORTED_MODULE_0__.isValidElement)(children) ? clone : null);
};
SelectIcon.displayName = "SelectIcon";



/***/ }),

/***/ 85720:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(14416);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(51469);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(48641);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(47741);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(57026);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(71197);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(18132);
/* harmony import */ var src_icons__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(60581);
/* harmony import */ var src_icons__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(36717);
/* harmony import */ var src_redux_sell_offer_actions__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(16648);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(42940);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);











const ActionBar = _ref => {
  let {
    offersCount = null
  } = _ref;
  const visibleOnMobile = (0,_chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__/* .useBreakpointValue */ .Sx)({
    base: true,
    md: false
  });
  const orders = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useSelector */ .v9)(state => state.sell.orders);
  const offers = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useSelector */ .v9)(state => state.sell.filteredOffers);
  const filterMenuIsOpen = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useSelector */ .v9)(state => state.sell.filterMenuIsOpen);
  const dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useDispatch */ .I0)();
  const {
    t
  } = (0,react_i18next__WEBPACK_IMPORTED_MODULE_4__/* .useTranslation */ .$)();

  const toggleFilterMenuHandler = () => dispatch((0,src_redux_sell_offer_actions__WEBPACK_IMPORTED_MODULE_5__/* .toggleFilterMenu */ .hg)());

  const changeOrderHandler = _ref2 => {
    let {
      target: {
        value
      }
    } = _ref2;
    return dispatch((0,src_redux_sell_offer_actions__WEBPACK_IMPORTED_MODULE_5__/* .toggleOrder */ .YQ)(value));
  };

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.Fragment, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_6__/* .SimpleGrid */ .MI, {
      columns: {
        base: 1,
        md: 4
      },
      pr: "l",
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_6__/* .Box */ .xu, {
        textAlign: "left",
        display: {
          base: 'none',
          md: 'flex'
        },
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_7__/* .Button */ .zx, {
          onClick: toggleFilterMenuHandler,
          leftIcon: filterMenuIsOpen ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(src_icons__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {}) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(src_icons__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {}),
          color: "baseDark",
          fontFamily: "Montserrat-Medium",
          variant: "link",
          fontSize: "1rem",
          fontWeight: "normal",
          children: filterMenuIsOpen ? t('sellActionbarContainer:hideFilters') : t('sellActionbarContainer:showFilters')
        })
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_6__/* .Box */ .xu, {
        textAlign: "left",
        fontFamily: "Montserrat-SemiBold",
        fontSize: "1.375rem",
        pt: "2",
        pl: "3",
        children: t('sellActionbarContainer:nOffersFound', {
          count: offersCount || offers.results
        })
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_6__/* .Box */ .xu, {
        display: {
          base: 'none',
          md: 'flex'
        }
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_6__/* .Box */ .xu, {
        textAlign: "right",
        fontFamily: "Montserrat-SemiBold",
        fontSize: "1rem",
        display: {
          base: 'none',
          md: 'block'
        },
        children: [t('sellActionbarContainer:sortBy'), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_10__/* .Select */ .Ph, {
          variant: "flushed",
          display: "inline-block",
          width: "initial",
          ml: 4,
          fontFamily: "Montserrat-Regular",
          onChange: changeOrderHandler,
          children: orders.map(sort => /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("option", {
            value: sort.value,
            children: sort.label || sort.name
          }, sort.value))
        })]
      })]
    }), !visibleOnMobile && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_11__/* .Slide */ .Mi, {
      className: "offers-filters-desktop-container",
      in: filterMenuIsOpen,
      direction: "left",
      unmountOnExit: true,
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_6__/* .Box */ .xu, {
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(___WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {})
      })
    })]
  });
};

/* harmony default export */ __webpack_exports__["default"] = (ActionBar);

/***/ }),

/***/ 39236:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(48641);
/* harmony import */ var src_themes__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(75159);
/* harmony import */ var _chakra_ui_icons__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(3382);
/* harmony import */ var src_uikit__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(37026);
/* harmony import */ var src_uikit__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(29438);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);








const AutoPromo = _ref => {
  let {
    item
  } = _ref;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(src_uikit__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
    href: item.link || '',
    title: item.linkText || 'Scopri di più',
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__/* .Box */ .xu, {
      bg: item.layout === 'outline' ? 'baseWhite' : 'primaryGreen.800',
      bgImage: item.image ? `url(${item.image})` : '',
      bgPosition: item.image ? '95% 95%' : '',
      bgRepeat: item.image ? 'no-repeat' : '',
      bgSize: item.image ? '20%' : '',
      p: "l",
      h: "370px",
      borderRadius: 10,
      overflow: "hidden",
      borderColor: item.layout === 'outline' ? src_themes__WEBPACK_IMPORTED_MODULE_4__/* .theme.colors.borders.grey */ .r.colors.borders.grey : 'primaryGreen.800',
      borderWidth: 1,
      boxShadow: src_themes__WEBPACK_IMPORTED_MODULE_4__/* .theme.shadows.cards */ .r.shadows.cards,
      textAlign: "left",
      color: item.layout === 'outline' ? 'baseDark' : 'baseWhite',
      position: "relative",
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__/* .Heading */ .X6, {
        fontSize: "1.75rem",
        children: item.title
      }), item.text && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__/* .Text */ .xv, {
        marginTop: "s",
        fontFamily: "Montserrat-Medium",
        fontSize: "1.125rem",
        pb: "s",
        children: item.text
      }), item.listItems && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(src_uikit__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
        items: item.listItems,
        color: "baseDark"
      }), item.link && item.linkText && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__/* .Text */ .xv, {
        title: item.linkText,
        fontSize: "m",
        color: item.layout === 'outline' ? 'baseDark' : 'baseWhite',
        children: [item.linkText, " ", /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_icons__WEBPACK_IMPORTED_MODULE_6__/* .ArrowForwardIcon */ .mr, {})]
      })]
    })
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (AutoPromo);

/***/ }),

/***/ 23280:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(14416);
/* harmony import */ var src_components_common__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(62414);
/* harmony import */ var src_redux_sell_offer_selectors__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(32422);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);






const FilterTag = _ref => {
  let {
    item,
    groupKey,
    hasCloseButton,
    onClick
  } = _ref;
  const isHidden = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useSelector */ .v9)((0,src_redux_sell_offer_selectors__WEBPACK_IMPORTED_MODULE_3__/* .filterIsHidden */ .ai)(item, groupKey));

  if (isHidden) {
    return null;
  }

  const isSelected = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useSelector */ .v9)((0,src_redux_sell_offer_selectors__WEBPACK_IMPORTED_MODULE_3__/* .filterIsSelected */ .$W)(item, groupKey));
  const label = hasCloseButton && item.label && item.label !== '' ? item.label : item.name;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(src_components_common__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
    isSelected: isSelected,
    onClick: onClick,
    hasCloseButton: hasCloseButton,
    label: label
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (FilterTag);

/***/ }),

/***/ 42940:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ SellOffers_FiltersList; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 20 modules
var es = __webpack_require__(14416);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/index.esm.js
var index_esm = __webpack_require__(48641);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/useTranslation.js + 6 modules
var useTranslation = __webpack_require__(18132);
// EXTERNAL MODULE: ./src/redux/sell-offer/actions.ts
var actions = __webpack_require__(16648);
// EXTERNAL MODULE: ./src/themes/index.tsx + 3 modules
var themes = __webpack_require__(75159);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/SellOffers/FiltersListBox.tsx





const FiltersListBox = _ref => {
  let {
    display,
    children
  } = _ref;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
    borderRadius: {
      base: 0,
      md: 10
    },
    bg: "baseWhite",
    p: "l",
    mt: "xxs",
    borderWidth: {
      base: 0,
      md: 1
    },
    borderColor: themes/* theme.colors.borders.grey */.r.colors.borders.grey,
    boxShadow: themes/* theme.shadows.cards */.r.shadows.cards,
    textAlign: "left",
    display: display,
    whiteSpace: {
      base: 'nowrap',
      md: 'normal'
    },
    children: children
  });
};

/* harmony default export */ var SellOffers_FiltersListBox = (FiltersListBox);
// EXTERNAL MODULE: ./src/components/SellOffers/FilterTag.tsx
var FilterTag = __webpack_require__(23280);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/media-query/dist/index.esm.js
var dist_index_esm = __webpack_require__(51469);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/accordion/dist/index.esm.js + 1 modules
var accordion_dist_index_esm = __webpack_require__(27190);
;// CONCATENATED MODULE: ./src/components/SellOffers/FiltersListItemsWrapper.tsx




const FiltersListItemsWrapper = _ref => {
  let {
    items,
    isMobile,
    listedRows,
    children
  } = _ref;

  if (items.some(item => item.icon !== undefined) && !isMobile) {
    return listedRows ? /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* SimpleGrid */.MI, {
      minChildWidth: "100%",
      spacing: "8px",
      children: children
    }) : /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* SimpleGrid */.MI, {
      minChildWidth: "5.625rem",
      spacing: "8px",
      children: children
    });
  }

  return /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
    overflowX: {
      base: 'scroll',
      md: null
    },
    paddingBottom: {
      base: '0.5rem',
      md: null
    },
    children: children
  });
};

/* harmony default export */ var SellOffers_FiltersListItemsWrapper = (FiltersListItemsWrapper);
// EXTERNAL MODULE: ./src/components/common/Offers/FilterTagImage.tsx
var FilterTagImage = __webpack_require__(17679);
// EXTERNAL MODULE: ./src/redux/sell-offer/selectors.ts
var selectors = __webpack_require__(32422);
;// CONCATENATED MODULE: ./src/components/SellOffers/FilterTagImage.tsx






const FilterTagImage_FilterTagImage = _ref => {
  let {
    item,
    groupKey,
    onClick,
    isMobile
  } = _ref;
  const isHidden = (0,es/* useSelector */.v9)((0,selectors/* filterIsHidden */.ai)(item, groupKey));

  if (isHidden) {
    return null;
  }

  const isSelected = (0,es/* useSelector */.v9)((0,selectors/* filterIsSelected */.$W)(item, groupKey));
  return /*#__PURE__*/(0,jsx_runtime.jsx)(FilterTagImage/* default */.Z, {
    isSelected: isSelected,
    label: item.name,
    icon: item.icon,
    isMobile: isMobile,
    onClick: onClick
  });
};

/* harmony default export */ var SellOffers_FilterTagImage = (FilterTagImage_FilterTagImage);
// EXTERNAL MODULE: ./src/components/common/Offers/FilterTagCheckbox.tsx
var FilterTagCheckbox = __webpack_require__(96406);
;// CONCATENATED MODULE: ./src/components/SellOffers/FilterTagCheckbox.tsx






const FilterTagCheckbox_FilterTagCheckbox = _ref => {
  let {
    item,
    groupKey,
    onClick
  } = _ref;
  const isHidden = (0,es/* useSelector */.v9)((0,selectors/* filterIsHidden */.ai)(item, groupKey));

  if (isHidden) {
    return null;
  }

  const isSelected = (0,es/* useSelector */.v9)((0,selectors/* filterIsSelected */.$W)(item, groupKey));
  return /*#__PURE__*/(0,jsx_runtime.jsx)(FilterTagCheckbox/* default */.Z, {
    isChecked: isSelected,
    onChange: onClick,
    label: item.name
  });
};

/* harmony default export */ var SellOffers_FilterTagCheckbox = (FilterTagCheckbox_FilterTagCheckbox);
;// CONCATENATED MODULE: ./src/components/SellOffers/FiltersListItemContent.tsx








const FiltersListItemContent = _ref => {
  let {
    filter
  } = _ref;
  const isMobile = (0,dist_index_esm/* useBreakpointValue */.Sx)({
    base: true,
    md: false
  });
  const dispatch = (0,es/* useDispatch */.I0)();

  const toggleFilterHandler = (filter, groupKey) => dispatch((0,actions/* toggleFilter */.cT)(filter.value, groupKey));

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(accordion_dist_index_esm/* AccordionItem */.Qd, {
    borderBottomWidth: {
      base: '0 !important'
    },
    borderTopWidth: {
      base: '0',
      md: '1px'
    },
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(accordion_dist_index_esm/* AccordionButton */.KF, {
      paddingInlineStart: "0",
      paddingInlineEnd: "0",
      py: 4,
      _hover: {
        background: 'none'
      },
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
        flex: "1",
        textAlign: "left",
        textTransform: "uppercase",
        fontFamily: "Montserrat-SemiBold",
        children: filter.label
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(accordion_dist_index_esm/* AccordionIcon */.XE, {})]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(accordion_dist_index_esm/* AccordionPanel */.Hk, {
      paddingInlineStart: "0",
      paddingInlineEnd: "0",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(SellOffers_FiltersListItemsWrapper, {
        items: filter.items,
        isMobile: isMobile,
        listedRows: filter.type === 'check',
        children: filter.type === 'icon' ? filter.items.map(item => /*#__PURE__*/(0,jsx_runtime.jsx)(SellOffers_FilterTagImage, {
          isMobile: isMobile,
          item: item,
          groupKey: filter.key,
          onClick: () => toggleFilterHandler(item, filter.key)
        }, `filters-brands-${item.name}-${item.value}`)) : filter.type === 'check' && !isMobile ? filter.items.map(item => /*#__PURE__*/(0,jsx_runtime.jsx)(SellOffers_FilterTagCheckbox, {
          item: item,
          groupKey: filter.key,
          onClick: () => toggleFilterHandler(item, filter.key)
        }, `filters-${item.name}-${item.value}`)) : filter.items.map(item => /*#__PURE__*/(0,jsx_runtime.jsx)(FilterTag/* default */.Z, {
          item: item,
          groupKey: filter.key,
          onClick: () => toggleFilterHandler(item, filter.key)
        }, `filters-${item.name}-${item.value}`))
      })
    })]
  });
};

/* harmony default export */ var SellOffers_FiltersListItemContent = (FiltersListItemContent);
// EXTERNAL MODULE: ./src/components/common/Offers/FilterSwitch.tsx
var FilterSwitch = __webpack_require__(50178);
;// CONCATENATED MODULE: ./src/components/SellOffers/FilterSwitch.tsx






const FilterSwitch_FilterSwitch = _ref => {
  let {
    groupKey,
    title,
    label,
    onChange
  } = _ref;
  const isSelected = (0,es/* useSelector */.v9)((0,selectors/* filterIsSelected */.$W)({
    label,
    name: title,
    value: '1'
  }, groupKey));
  const {
    0: checked,
    1: setChecked
  } = (0,react.useState)(isSelected);
  (0,react.useEffect)(() => {
    return setChecked(isSelected);
  }, [isSelected]);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(FilterSwitch/* default */.Z, {
    label: label,
    title: title,
    isSelected: checked,
    onChange: onChange
  });
};

/* harmony default export */ var SellOffers_FilterSwitch = (FilterSwitch_FilterSwitch);
;// CONCATENATED MODULE: ./src/components/SellOffers/FiltersListItemNoChildren.tsx









const FiltersListItemNoChildren = _ref => {
  let {
    items,
    groupKey
  } = _ref;
  const dispatch = (0,es/* useDispatch */.I0)();

  const toggleFilterHandler = filter => dispatch((0,actions/* toggleFilter */.cT)(filter.value, groupKey));

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
      flex: "1",
      textAlign: "left",
      textTransform: "uppercase",
      fontFamily: "Montserrat-SemiBold",
      display: {
        base: 'block',
        md: 'none'
      },
      children: "Tag"
    }), items.map(item => /*#__PURE__*/(0,jsx_runtime.jsx)(FilterTag/* default */.Z, {
      item: item,
      groupKey: groupKey,
      onClick: () => toggleFilterHandler(item)
    }, `filters-ref-${item.name}-${item.value}`))]
  });
};

/* harmony default export */ var SellOffers_FiltersListItemNoChildren = (FiltersListItemNoChildren);
;// CONCATENATED MODULE: ./src/components/SellOffers/FiltersListItem.tsx





const FiltersListItem = _ref => {
  let {
    items
  } = _ref;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(accordion_dist_index_esm/* Accordion */.UQ, {
    fontFamily: "Montserrat-Regular",
    allowToggle: true,
    children: Object.keys(items).map(idx => /*#__PURE__*/(0,jsx_runtime.jsx)(SellOffers_FiltersListItemContent, {
      filter: items[idx]
    }, idx))
  });
};

/* harmony default export */ var SellOffers_FiltersListItem = (FiltersListItem);
;// CONCATENATED MODULE: ./src/components/SellOffers/FiltersListGroup.tsx










const FiltersListGroup = _ref => {
  let {
    groupLabel,
    group
  } = _ref;
  const dispatch = (0,es/* useDispatch */.I0)();
  const isMobile = (0,dist_index_esm/* useBreakpointValue */.Sx)({
    base: true,
    md: false
  });

  const toggleFilterHandler = (value, groupKey) => dispatch((0,actions/* toggleFilter */.cT)(value, groupKey));

  return isMobile ? /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children: group.length === 1 ? /*#__PURE__*/(0,jsx_runtime.jsx)(accordion_dist_index_esm/* Accordion */.UQ, {
      fontFamily: "Montserrat-Regular",
      allowToggle: true,
      defaultIndex: [0],
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(SellOffers_FiltersListBox, {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(SellOffers_FiltersListItemContent, {
          filter: group[0]
        })
      })
    }) : group.map(filter => /*#__PURE__*/(0,jsx_runtime.jsx)(accordion_dist_index_esm/* Accordion */.UQ, {
      fontFamily: "Montserrat-Regular",
      allowToggle: true,
      defaultIndex: [0],
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(SellOffers_FiltersListBox, {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(SellOffers_FiltersListItemContent, {
          filter: filter
        })
      })
    }, filter.label))
  }) : /*#__PURE__*/(0,jsx_runtime.jsx)(SellOffers_FiltersListBox, {
    children: group.length === 1 ? /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
      children: group[0].type === 'switch' ? /*#__PURE__*/(0,jsx_runtime.jsx)(SellOffers_FilterSwitch, {
        groupKey: group[0].key,
        title: group[0].group,
        label: group[0].label,
        onChange: _ref2 => {
          let {
            target
          } = _ref2;
          return toggleFilterHandler(target.value, group[0].key);
        }
      }) : /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Heading */.X6, {
          as: "h4",
          fontFamily: "Montserrat-SemiBold",
          fontSize: themes/* theme.space.m */.r.space.m,
          color: "baseNeutral.700",
          pb: 4,
          children: groupLabel
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(SellOffers_FiltersListItemNoChildren, {
          items: group[0].items,
          groupKey: group[0].key
        })]
      })
    }) : /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Heading */.X6, {
        as: "h4",
        fontFamily: "Montserrat-SemiBold",
        fontSize: themes/* theme.space.m */.r.space.m,
        color: "baseNeutral.700",
        pb: 4,
        children: groupLabel
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(SellOffers_FiltersListItem, {
        items: group
      })]
    })
  });
};

/* harmony default export */ var SellOffers_FiltersListGroup = (FiltersListGroup);
;// CONCATENATED MODULE: ./src/components/SellOffers/FiltersListGroups.tsx






const FiltersListGroups = () => {
  const filters = (0,es/* useSelector */.v9)(state => state.sell.filters);
  const filtersGrouped = filters.reduce((r, a) => {
    r[a.group] = r[a.group] || [];
    r[a.group].push(a);
    return r;
  }, Object.create(null));
  return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children: Object.keys(filtersGrouped).map(filterGroup => /*#__PURE__*/(0,jsx_runtime.jsx)(SellOffers_FiltersListGroup, {
      groupLabel: filterGroup,
      group: filtersGrouped[filterGroup]
    }, filterGroup))
  });
};

/* harmony default export */ var SellOffers_FiltersListGroups = (FiltersListGroups);
;// CONCATENATED MODULE: ./src/components/SellOffers/FiltersList.tsx











const FiltersList = () => {
  const {
    t
  } = (0,useTranslation/* useTranslation */.$)();
  const suggestedFilters = (0,es/* useSelector */.v9)(state => state.sell.suggestedFilters);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(SellOffers_FiltersListBox, {
      display: {
        base: 'block',
        md: 'none'
      },
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
        fontFamily: "Montserrat-SemiBold",
        fontWeight: "bold",
        fontSize: themes/* theme.space.s */.r.space.s,
        color: "baseNeutral.700",
        pb: "4",
        children: t('offersListContainer:suggestedFilters')
      }), suggestedFilters.map(filterGroup => filterGroup.items.map(item => /*#__PURE__*/(0,jsx_runtime.jsx)(FilterTag/* default */.Z, {
        item: item,
        groupKey: filterGroup.key,
        onClick: () => (0,actions/* toggleFilter */.cT)(item.value, filterGroup.key)
      }, `suggested-${item.name}-${item.value}`)))]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(SellOffers_FiltersListGroups, {})]
  });
};

/* harmony default export */ var SellOffers_FiltersList = (FiltersList);

/***/ }),

/***/ 50178:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(48641);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(68185);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);






const FilterSwitch = _ref => {
  let {
    title,
    label,
    isSelected,
    onChange
  } = _ref;
  const {
    0: checked,
    1: setChecked
  } = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(isSelected);
  const {
    0: isMounted,
    1: setMount
  } = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    setChecked(isSelected);
  }, [isSelected]);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    setMount(true);
  }, []);

  if (!isMounted) {
    return null;
  }

  const onSwitchChange = evt => {
    const {
      target: {
        value
      }
    } = evt;
    setChecked(value === '1');
    onChange(evt);
    return value === '1';
  };

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xu, {
      flex: "1",
      textAlign: "left",
      textTransform: "uppercase",
      fontFamily: "Montserrat-SemiBold",
      children: title
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xu, {
      as: "span",
      fontFamily: "Montserrat-Medium",
      fontSize: "0.875rem",
      color: "#656b72",
      children: label
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__/* .Switch */ .r, {
      colorScheme: "green",
      isChecked: checked,
      float: "right",
      value: "1",
      onChange: onSwitchChange
    })]
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (FilterSwitch);

/***/ }),

/***/ 62414:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47741);
/* harmony import */ var _chakra_ui_icons__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(3382);
/* harmony import */ var src_themes__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(75159);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);






const FilterTag = _ref => {
  let {
    isSelected,
    hasCloseButton,
    label,
    onClick
  } = _ref;
  const {
    0: isMounted,
    1: setMount
  } = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    setMount(true);
  }, []);

  if (!isMounted) {
    return null;
  }

  const bgColor = isSelected ? src_themes__WEBPACK_IMPORTED_MODULE_2__/* .theme.colors.primaryGreen[300] */ .r.colors.primaryGreen[300] : 'white';
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__/* .Button */ .zx, {
    color: src_themes__WEBPACK_IMPORTED_MODULE_2__/* .theme.colors.primaryGreen[900] */ .r.colors.primaryGreen[900],
    variant: "outline",
    fontFamily: "Montserrat-Medium",
    fontWeight: "normal",
    size: "xs",
    h: "32px",
    mr: 1,
    my: 1,
    borderRadius: 4,
    bg: bgColor,
    _hover: {
      backgroundColor: bgColor
    },
    borderColor: src_themes__WEBPACK_IMPORTED_MODULE_2__/* .theme.colors.primaryGreen[300] */ .r.colors.primaryGreen[300],
    userSelect: "none",
    onClick: onClick,
    rightIcon: hasCloseButton ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_icons__WEBPACK_IMPORTED_MODULE_4__/* .CloseIcon */ .Tw, {
      boxSize: "0.7rem"
    }) : undefined,
    children: label
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (FilterTag);

/***/ }),

/***/ 96406:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9135);
/* harmony import */ var src_themes__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(75159);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);





const FilterTagCheckbox = _ref => {
  let {
    isChecked,
    label,
    onChange
  } = _ref;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Checkbox */ .XZ, {
    fontFamily: "Montserrat-Medium",
    color: "baseDark",
    borderColor: src_themes__WEBPACK_IMPORTED_MODULE_3__/* .theme.colors.primaryGreen[900] */ .r.colors.primaryGreen[900],
    colorScheme: "primaryGreenCheckboxFilter",
    isChecked: isChecked,
    display: "block",
    size: "lg",
    lineHeight: "1.2",
    mb: "s",
    className: "filterCheck",
    onChange: onChange,
    children: label
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (FilterTagCheckbox);

/***/ }),

/***/ 17679:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var src_themes__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(75159);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(48641);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);







const FilterTagImage = _ref => {
  let {
    isSelected,
    label,
    icon,
    onClick,
    isMobile
  } = _ref;
  const borderColor = isSelected ? `${src_themes__WEBPACK_IMPORTED_MODULE_3__/* .theme.colors.green[600] */ .r.colors.green[600]}, 0 2px 8px 0 rgba(44, 190, 97, 0.13)` : src_themes__WEBPACK_IMPORTED_MODULE_3__/* .theme.colors.borders.grey */ .r.colors.borders.grey;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__/* .Badge */ .Ct, {
    suppressHydrationWarning: true,
    as: "button",
    variant: "outline",
    p: 2,
    m: 1,
    h: isMobile ? '4.563rem' : '4.688rem',
    w: isMobile ? '5.625rem' : '',
    borderRadius: 4,
    textTransform: "none",
    boxShadow: `inset 0 0 0px 1px ${borderColor}`,
    color: "baseNeutral.700",
    onClick: onClick,
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
      src: icon,
      alt: "",
      width: "40",
      height: "40"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("div", {
      children: label
    })]
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (FilterTagImage);

/***/ }),

/***/ 95287:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(14416);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(48641);
/* harmony import */ var src_components_SellOffers___WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(85720);
/* harmony import */ var src_components_SellOffers___WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(39236);
/* harmony import */ var src_components_SellOffers___WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(74682);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(18132);
/* harmony import */ var src_redux_sell_offer__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(16648);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);










const Pagination = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(() => Promise.all(/* import() */[__webpack_require__.e(6319), __webpack_require__.e(3344), __webpack_require__.e(804), __webpack_require__.e(1937), __webpack_require__.e(285)]).then(__webpack_require__.bind(__webpack_require__, 90285)), {
  loadableGenerated: {
    webpack: () => [/*require.resolve*/(90285)]
  }
});
const HomeOffersList = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(() => Promise.all(/* import() */[__webpack_require__.e(7620), __webpack_require__.e(1717)]).then(__webpack_require__.bind(__webpack_require__, 9586)), {
  loadableGenerated: {
    webpack: () => [/*require.resolve*/(9586)]
  }
});

const LandingSellOffersContainer = () => {
  const {
    t
  } = (0,react_i18next__WEBPACK_IMPORTED_MODULE_4__/* .useTranslation */ .$)();
  const dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useDispatch */ .I0)();
  const filterMenuIsOpen = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(state => state.sell.filterMenuIsOpen);
  const offers = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(state => state.sell.filteredOffers);
  const otherOffers = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(state => state.sell.offers);

  const onPaginatorClickHandler = page => dispatch((0,src_redux_sell_offer__WEBPACK_IMPORTED_MODULE_5__/* .setListingPage */ .Dx)(page));

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.Fragment, {
    children: offers.items && offers.items.length ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.Fragment, {
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(src_components_SellOffers___WEBPACK_IMPORTED_MODULE_6__["default"], {
        offersCount: offers.items.length
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_7__/* .Grid */ .rj, {
        templateColumns: {
          md: `repeat(${filterMenuIsOpen ? 2 : 3}, 1fr)`,
          lg: `repeat(${filterMenuIsOpen ? 3 : 4}, 1fr)`
        },
        gap: 6,
        px: "l",
        pt: "xxs",
        children: [offers.items.map(item => {
          return item.code === 'auto-promo' ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_7__/* .GridItem */ .P4, {
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(src_components_SellOffers___WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
              item: item
            })
          }, `${item.code}- ${item.title} `) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_7__/* .GridItem */ .P4, {
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(src_components_SellOffers___WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
              item: item
            })
          }, item.code);
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_7__/* .GridItem */ .P4, {
          colSpan: {
            md: filterMenuIsOpen ? 2 : 3,
            lg: filterMenuIsOpen ? 3 : 4
          },
          mt: "-2",
          textAlign: "left",
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(Pagination, {
            currentPage: offers.currentPage,
            perPage: offers.pageSize,
            total: offers.results,
            onClick: onPaginatorClickHandler
          })
        }, "load-more")]
      })]
    }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.Fragment, {
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_7__/* .GridItem */ .P4, {
        colSpan: {
          md: filterMenuIsOpen ? 2 : 3,
          lg: filterMenuIsOpen ? 3 : 4
        },
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_7__/* .Heading */ .X6, {
          as: "h3",
          fontSize: "2xl",
          fontFamily: "Montserrat-SemiBold",
          children: t('sellPage:notFound')
        })
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_7__/* .GridItem */ .P4, {
        colSpan: {
          md: filterMenuIsOpen ? 2 : 3,
          lg: filterMenuIsOpen ? 3 : 4
        },
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(HomeOffersList, {
          w: "100%",
          action: t('indexPage:sell_offers.action'),
          alt: t('indexPage:sell_offers.alt'),
          href: "/offerte-auto",
          offers: otherOffers,
          paddingLeft: "l",
          paddingRight: "l",
          bgColor: "baseNeutral.100"
        })
      })]
    })
  });
};

/* harmony default export */ __webpack_exports__["default"] = (LandingSellOffersContainer);

/***/ }),

/***/ 60581:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);


const ArrowLeftIcon = () => /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "18",
  height: "18",
  viewBox: "0 0 18 18",
  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
    fill: "none",
    fillRule: "evenodd",
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
      fill: "#262626",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
        d: "M11.804 5c.275 0 .499.224.499.499v9.813l3.624-3.586c.183-.184.48-.184.664 0l.773.773c.184.184.184.48 0 .664l-5.781 5.735c-.184.183-.48.183-.664 0l-5.781-5.735c-.184-.183-.184-.48 0-.664l.773-.773c.184-.184.48-.184.664 0l3.623 3.587.001-9.814c0-.245.177-.449.41-.49l.09-.009z",
        transform: "translate(-48 -331) translate(45 328) matrix(-1 0 0 1 23 0) rotate(-90 11.251 12.018)"
      })
    })
  })
});

/* harmony default export */ __webpack_exports__["Z"] = (ArrowLeftIcon);

/***/ }),

/***/ 36717:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);


const ArrowRightIcon = () => /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "18",
  height: "18",
  viewBox: "0 0 18 18",
  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
    fill: "none",
    fillRule: "evenodd",
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
      fill: "#262626",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
        d: "M9.603 3.75c.207 0 .374.168.374.374v7.36l2.718-2.69c.138-.137.36-.137.498 0l.58.58c.138.138.138.36 0 .498l-4.336 4.301c-.137.138-.36.138-.498 0l-4.336-4.3c-.137-.138-.137-.36 0-.499l.58-.58c.138-.137.36-.137.498 0l2.718 2.69v-7.36c0-.18.129-.331.3-.366l.075-.008z",
        transform: "translate(-1377 -1392) translate(45 1377) translate(1146 14) translate(186 1) rotate(-90 9.188 9.013)"
      })
    })
  })
});

/* harmony default export */ __webpack_exports__["Z"] = (ArrowRightIcon);

/***/ }),

/***/ 29160:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);


const SuccessIcon = () => /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "18",
  height: "18",
  viewBox: "0 0 18 18",
  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
    fill: "none",
    fillRule: "evenodd",
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
      fill: "#41A476",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
        d: "M9 1.5c4.142 0 7.5 3.358 7.5 7.5 0 4.142-3.358 7.5-7.5 7.5-4.142 0-7.5-3.358-7.5-7.5 0-4.142 3.358-7.5 7.5-7.5zm0 1.452C5.657 2.952 2.952 5.657 2.952 9S5.657 15.048 9 15.048 15.048 12.343 15.048 9 12.343 2.952 9 2.952zm4.24 3.94c.141.141.14.371-.002.512l-5.22 5.178c-.142.141-.371.14-.513-.002L4.76 9.812c-.141-.142-.14-.372.002-.513l.687-.682c.142-.14.372-.14.513.003l1.809 1.822 4.274-4.24c.143-.141.372-.14.514.002l.681.687z",
        transform: "translate(-86 -2134) translate(0 1936) translate(86 96) translate(0 99) translate(0 3)"
      })
    })
  })
});

/* harmony default export */ __webpack_exports__["Z"] = (SuccessIcon);

/***/ }),

/***/ 37026:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(48641);
/* harmony import */ var src_themes__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(75159);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);





const CardLink = _ref => {
  let {
    href,
    onClick,
    title,
    bg,
    children
  } = _ref;
  return href ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .LinkBox */ .fG, {
    title: title,
    borderRadius: 10,
    bg: bg || 'baseWhite',
    pb: "l",
    overflow: "hidden",
    borderColor: src_themes__WEBPACK_IMPORTED_MODULE_3__/* .theme.colors.borders.grey */ .r.colors.borders.grey,
    borderWidth: 1,
    boxShadow: src_themes__WEBPACK_IMPORTED_MODULE_3__/* .theme.shadows.cards */ .r.shadows.cards,
    _hover: {
      textDecoration: 'none',
      boxShadow: '0 4px 12px 0px rgba(65, 164, 118, 0.22)'
    },
    children: children
  }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xu, {
    title: title,
    onClick: onClick,
    cursor: "pointer",
    children: children
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (CardLink);

/***/ }),

/***/ 29438:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _codebuild_output_src1686024941_src_mr_planner_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _codebuild_output_src1686024941_src_mr_planner_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4730);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(53918);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(48641);
/* harmony import */ var src_icons__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(29160);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);


const _excluded = ["items", "color", "fontSize", "fontFamily", "icon"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_codebuild_output_src1686024941_src_mr_planner_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }







const StyledList = /*#__PURE__*/(0,styled_components__WEBPACK_IMPORTED_MODULE_3__["default"])(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__/* .ListItem */ .HC).withConfig({
  componentId: "sc-b5lt8m-0"
})(["& svg{display:inline;}"]);

const ListWithIcons = _ref => {
  let {
    items,
    color,
    fontSize,
    fontFamily,
    icon
  } = _ref,
      props = (0,_codebuild_output_src1686024941_src_mr_planner_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_ref, _excluded);

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__/* .Box */ .xu, {
    paddingY: "l",
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__/* .List */ .aV, {
      spacing: 3,
      children: items.map(item => /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)(StyledList, _objectSpread(_objectSpread({
        color: color || 'baseWhite',
        fontFamily: fontFamily || 'Montserrat-SemiBold',
        fontSize: fontSize || '1rem',
        lineHeight: "22.8px",
        letterSpacing: "0.3px",
        textAlign: "left",
        py: "auto"
      }, props), {}, {
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__/* .ListIcon */ .DE, {
          as: icon || src_icons__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z,
          fontSize: "1rem",
          lineHeight: "22.8px"
        }), ` ${item}`]
      }), item))
    })
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (ListWithIcons);

/***/ }),

/***/ 55352:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Jj": function() { return /* binding */ getWindow; },
/* harmony export */   "Me": function() { return /* binding */ getDocument; }
/* harmony export */ });
/* unused harmony exports extend, ssrDocument, ssrWindow */
/**
 * SSR Window 4.0.2
 * Better handling for window object in SSR environment
 * https://github.com/nolimits4web/ssr-window
 *
 * Copyright 2021, Vladimir Kharlampidi
 *
 * Licensed under MIT
 *
 * Released on: December 13, 2021
 */

/* eslint-disable no-param-reassign */
function isObject(obj) {
  return obj !== null && typeof obj === 'object' && 'constructor' in obj && obj.constructor === Object;
}

function extend() {
  let target = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  let src = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  Object.keys(src).forEach(key => {
    if (typeof target[key] === 'undefined') target[key] = src[key];else if (isObject(src[key]) && isObject(target[key]) && Object.keys(src[key]).length > 0) {
      extend(target[key], src[key]);
    }
  });
}

const ssrDocument = {
  body: {},

  addEventListener() {},

  removeEventListener() {},

  activeElement: {
    blur() {},

    nodeName: ''
  },

  querySelector() {
    return null;
  },

  querySelectorAll() {
    return [];
  },

  getElementById() {
    return null;
  },

  createEvent() {
    return {
      initEvent() {}

    };
  },

  createElement() {
    return {
      children: [],
      childNodes: [],
      style: {},

      setAttribute() {},

      getElementsByTagName() {
        return [];
      }

    };
  },

  createElementNS() {
    return {};
  },

  importNode() {
    return null;
  },

  location: {
    hash: '',
    host: '',
    hostname: '',
    href: '',
    origin: '',
    pathname: '',
    protocol: '',
    search: ''
  }
};

function getDocument() {
  const doc = typeof document !== 'undefined' ? document : {};
  extend(doc, ssrDocument);
  return doc;
}

const ssrWindow = {
  document: ssrDocument,
  navigator: {
    userAgent: ''
  },
  location: {
    hash: '',
    host: '',
    hostname: '',
    href: '',
    origin: '',
    pathname: '',
    protocol: '',
    search: ''
  },
  history: {
    replaceState() {},

    pushState() {},

    go() {},

    back() {}

  },
  CustomEvent: function CustomEvent() {
    return this;
  },

  addEventListener() {},

  removeEventListener() {},

  getComputedStyle() {
    return {
      getPropertyValue() {
        return '';
      }

    };
  },

  Image() {},

  Date() {},

  screen: {},

  setTimeout() {},

  clearTimeout() {},

  matchMedia() {
    return {};
  },

  requestAnimationFrame(callback) {
    if (typeof setTimeout === 'undefined') {
      callback();
      return null;
    }

    return setTimeout(callback, 0);
  },

  cancelAnimationFrame(id) {
    if (typeof setTimeout === 'undefined') {
      return;
    }

    clearTimeout(id);
  }

};

function getWindow() {
  const win =  true ? window : 0;
  extend(win, ssrWindow);
  return win;
}



/***/ })

}]);